import { render } from "./DialogNotExistSaloon.vue?vue&type=template&id=d1140822"
import script from "./DialogNotExistSaloon.vue?vue&type=script&lang=js"
export * from "./DialogNotExistSaloon.vue?vue&type=script&lang=js"
script.render = render

export default script